import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./loginsignup.css";

const LoginPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const LeftRef = useRef();
    const RightRef = useRef();

    const [isLeftVisible, setIsLeftVisible] = useState(false);
    const [isRightVisible, setIsRightVisible] = useState(false);

    useEffect(() => {
        const LeftObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsLeftVisible(true);
                    LeftObserver.unobserve(entry.target);
                }
            });
        });

        const RightObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsRightVisible(true);
                    RightObserver.unobserve(entry.target);
                }
            });
        });

        if (LeftRef.current) {
            LeftObserver.observe(LeftRef.current);
        }

        if (RightRef.current) {
            RightObserver.observe(RightRef.current);
        }

        return () => {
            if (LeftRef.current) {
                LeftObserver.unobserve(LeftRef.current);
            }

            if (RightRef.current) {
                RightObserver.unobserve(RightRef.current);
            }
        };
    }, []);

    const handleLogin = (e) => {
        e.preventDefault();

        const validEmail = "aloha@online.com";
        const validPassword = "Aloha1234";

        if (email === validEmail && password === validPassword) {
            setSuccess(true);
            setError("");

            setTimeout(() => {
                navigate("/profile");
            }, 2000);
        } else {
            setSuccess(false);
            setError("Invalid email or password. Please try again.");
        }
    };

    return (
        <div className="login-signup-main-container">
            <div className='md:grid grid-cols-2'>
                <div className={`login-signup-left-container flex items-center relative  ${isLeftVisible ? "fade-in" : ""}`} ref={LeftRef}>

                    <div className="absolute -right-9 top-16 h-[145px] w-[190px] bg-[radial-gradient(#cacccc_3px,transparent_3px)] [background-size:16px_16px] z-2"></div>
                    <div className='login-img1 z-3'></div>
                    <div className="absolute bottom-0 left-0 h-0 w-0 border-[100px] border-transparent border-b-[#DAA520] border-l-[#DAA520] z-2"></div>
                </div>

                <div className={`login-signup-right-container ${isRightVisible ? "fade-in" : ""}`} ref={RightRef}>
                    <h1 className='login-signup-title1'>Welcome Back!</h1>
                    <p className='login-signup-text1'>Connect with AI entrepreneurs, investors, and industry leaders. Log in to grow your projects and be part of the future of innovation!</p>

                    <form className="login-signup-form" onSubmit={handleLogin}>
                        <div className="form-group">
                            <label htmlFor="email" className="login-signup-label">Email</label>
                            <input
                                type="text"
                                id="email"
                                placeholder="Enter your email"
                                className="login-signup-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password" className="login-signup-label">Password</label>
                            <input
                                type="password"
                                id="password"
                                placeholder="Enter your password"
                                className="login-signup-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                        <div className="form-check my-2">
                            <input type="checkbox" className="form-check-input" id="rememberMe" />
                            <label className="form-check-label" htmlFor="rememberMe">Remember Me</label>
                        </div>

                        {success && <p className="text-green-600  font-bold">Login Successful!</p>}

                        {error && <p className="text-red-600 ">{error}</p>}

                        <div className="flex justify-content-center">
                            <button type="submit" className="login-signup-button">Login</button>
                        </div>
                    </form>

                    <p className='login-signup-text2'>Don't have an account? <a href="/sign-up" className='login-signup-link'>Sign Up!</a></p>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
